import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticket-graphic-body',
  templateUrl: './ticket-graphic-body.component.html',
  styleUrls: ['./ticket-graphic-body.component.scss'],
})
export class TicketGraphicBodyComponent implements OnInit {
  @Input()
  padding: number = 40;

  constructor() { }

  getPadding(): string {
    return `0 ${this.padding}px`;
  }

  ngOnInit() {}

}
